import { cn } from "@/lib/utils";
import { ClassAttributes, HTMLAttributes } from "react";

// Re-export all the component parts
export { ContentAbstract } from "./components/ContentAbstract";
export { ContentAuthorName } from "./components/ContentAuthorName";
export { ContentBookmark } from "./components/ContentBookmark";
export { ContentCategoryChip } from "./components/ContentCategoryChip";
export { ContentSourceAuthorHeader } from "./components/ContentSourceAuthorHeader";
export { ContentSourceImg } from "./components/ContentSourceImg";
export { ContentTags } from "./components/ContentTags";
export { ContentThumbnailImg } from "./components/ContentThumbnailImg";
export { ContentThumbnailWithActions } from "./components/ContentThumbnailWithActions";
export { ContentTitle } from "./components/ContentTitle";
export { ContentUpdateTime } from "./components/ContentUpdateTime";

// Main ContentCardLayout component
export const ContentCardLayout = ({
    className,
    ...props
}: ClassAttributes<HTMLElement> & HTMLAttributes<HTMLElement>) => {
    return (
        <article
            className={cn("flex cursor-pointer flex-col", className)}
            {...props}
        />
    );
};
